export enum DocumentDetailsContentSubtype {
    Blinded = 1,
    StaffBlinded,
    DvmsBlinded,
    Visible,
}

export const DocumentDetailsContentSubtypeEnumToStringMapping: {
    [key in DocumentDetailsContentSubtype]?: keyof typeof DocumentDetailsContentSubtype;
} = {
    [DocumentDetailsContentSubtype.Blinded]: 'Blinded',
    [DocumentDetailsContentSubtype.StaffBlinded]: 'StaffBlinded',
    [DocumentDetailsContentSubtype.DvmsBlinded]: 'DvmsBlinded',
    [DocumentDetailsContentSubtype.Visible]: 'Visible',
};

export const DocumentDetailsContentSubtypeStringToEnumMapping: {
    [key: string]: DocumentDetailsContentSubtype;
} = {
    'Blinded': DocumentDetailsContentSubtype.Blinded,
    'StaffBlinded': DocumentDetailsContentSubtype.StaffBlinded,
    'DvmsBlinded': DocumentDetailsContentSubtype.DvmsBlinded,
    'Visible': DocumentDetailsContentSubtype.Visible,
};

export const DocumentDetailsContentSubtypeOptions = [
    { id: DocumentDetailsContentSubtype.Blinded, fieldName: 'blinded', label: 'Fully Blinded' },
    { id: DocumentDetailsContentSubtype.StaffBlinded, fieldName: 'staffBlinded', label: 'Staff Blinded' },
    { id: DocumentDetailsContentSubtype.DvmsBlinded, fieldName: 'dmvsBlinded', label: 'DVMs / Management Blinded' },
    { id: DocumentDetailsContentSubtype.Visible, fieldName: 'visible', label: 'Fully Visible' },
];
